if (!customElements.get('recipient-form')) {
	customElements.define(
		'recipient-form',
		class RecipientForm extends HTMLElement {
			constructor() {
				super()
				this.formId = this.dataset.recipientFormId
				this.checkboxInput = this.querySelector(`#Recipient-checkbox-${this.formId}`)
				this.hiddenControlField = this.querySelector(`#Recipient-control-${this.formId}`)
				this.fieldsContainer = this.querySelector('.gift-card-recipient__fields')
				this.recipientFieldsLiveRegion = this.querySelector(
					`#Recipient-fields-live-region-${this.formId}`
				)
				this.emailInput = this.querySelector(`#Recipient-email-${this.formId}`)
				this.nameInput = this.querySelector(`#Recipient-name-${this.formId}`)
				this.messageInput = this.querySelector(`#Recipient-message-${this.formId}`)
				this.sendonInput = this.querySelector(`#Recipient-send-on-${this.formId}`)
				this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${this.formId}`)

				if (this.offsetProperty) {
					this.offsetProperty.value = new Date().getTimezoneOffset().toString()
				}

				if (this.checkboxInput) {
					this.checkboxInput.disabled = false
				}

				this.addEventListener('change', this.onChange.bind(this))
				this.onChange()
			}

			inputFields() {
				return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput]
			}

			disableableFields() {
				return [...this.inputFields(), this.offsetProperty]
			}

			clearInputFields() {
				this.inputFields().forEach(field => {
					if (field) field.value = ''
				})
			}

			enableInputFields() {
				this.disableableFields().forEach(field => {
					if (field) field.disabled = false
				})
			}

			disableInputFields() {
				this.disableableFields().forEach(field => {
					if (field) field.disabled = true
				})
			}

			onChange() {
				const isChecked = this.checkboxInput && this.checkboxInput.checked

				if (isChecked) {
					if (this.fieldsContainer) this.fieldsContainer.hidden = false
					this.classList.add('is-expanded')
					if (this.hiddenControlField) this.hiddenControlField.disabled = true
					this.enableInputFields()
					if (this.recipientFieldsLiveRegion) {
						this.recipientFieldsLiveRegion.textContent = 'Gift card recipient form expanded'
					}
				} else {
					if (this.fieldsContainer) this.fieldsContainer.hidden = true
					this.classList.remove('is-expanded')
					if (this.hiddenControlField) this.hiddenControlField.disabled = true
					this.clearInputFields()
					this.disableInputFields()
					if (this.recipientFieldsLiveRegion) {
						this.recipientFieldsLiveRegion.textContent = 'Gift card recipient form collapsed'
					}
				}
			}
		}
	)
}
